export default __webpack_public_path__ + "static/media/orange-check.f7616967.svg";